import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, MapPin, Facebook, Instagram, Mail, Trophy, Calendar, Star, Download, Share, PlusSquare, Image as ImageIcon } from 'lucide-react';
import './App.css';
import logoImage from './gallery/logo.png';
import posterImage from './gallery/poster-1433.png';
import durgaHeroImage from './gallery/durga-hero.png';
import copperKettleLogo from './gallery/sponsors/copper-kettle-logo.png';
import PhotoGallery from './PhotoGallery';

const ANDROID_APK_URL = `${process.env.PUBLIC_URL}/downloads/shopnotori-pujo.apk`;

function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showIOSInstallHint, setShowIOSInstallHint] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsMenuOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="app-root">
      {/* Announcement Banner */}
      <div className="announcement-banner">
        <div className="banner-track">
          <span>🎊&nbsp; রেজিস্ট্রেশন শুরু হয়েছে! &nbsp;|&nbsp; এখনই যোগাযোগ করুন: +91 6289 492 935 &nbsp;|&nbsp; সেরা পুজো ১৪৩৩ &nbsp;|&nbsp; স্বপ্নতরী পরিবারের উদ্যোগে &nbsp;|&nbsp; পুরো দেশ জুড়ে যে কেউ অংশগ্রহণ করতে পারবেন &nbsp;|&nbsp; প্রবেশমূল্য ₹৫০০ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>🎊&nbsp; রেজিস্ট্রেশন শুরু হয়েছে! &nbsp;|&nbsp; এখনই যোগাযোগ করুন: +91 6289 492 935 &nbsp;|&nbsp; সেরা পুজো ১৪৩৩ &nbsp;|&nbsp; স্বপ্নতরী পরিবারের উদ্যোগে &nbsp;|&nbsp; পুরো দেশ জুড়ে যে কেউ অংশগ্রহণ করতে পারবেন &nbsp;|&nbsp; প্রবেশমূল্য ₹৫০০ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </div>
      </div>

      {/* Header */}
      <header className="glass-header">
        <nav className="nav-inner">
          <div className="nav-logo-container" onClick={() => scrollToSection('home')}>
            <img src={logoImage} alt="স্বপ্নতরী Logo" className="nav-logo" />
            <div className="logo-text">স্বপ্নতরী</div>
          </div>
          <div className="desktop-nav">
            <button onClick={() => scrollToSection('home')} className="nav-button">হোম</button>
            <button onClick={() => scrollToSection('competition')} className="nav-button">প্রতিযোগিতা</button>
            <button onClick={() => scrollToSection('prizes')} className="nav-button">পুরস্কার</button>
            <button onClick={() => scrollToSection('gallery')} className="nav-button">গ্যালারি</button>
            <button onClick={() => scrollToSection('contact')} className="nav-button">যোগাযোগ</button>
            <Link to="/banner" className="nav-button nav-button-banner">গর্বিত প্রতিযোগী ব্যানার</Link>
          </div>
          <button className="mobile-nav-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </nav>
        {isMenuOpen && (
          <div className="mobile-menu">
            <button onClick={() => scrollToSection('home')} className="mobile-menu-item">হোম</button>
            <button onClick={() => scrollToSection('competition')} className="mobile-menu-item">প্রতিযোগিতা</button>
            <button onClick={() => scrollToSection('prizes')} className="mobile-menu-item">পুরস্কার</button>
            <button onClick={() => scrollToSection('gallery')} className="mobile-menu-item">গ্যালারি</button>
            <button onClick={() => scrollToSection('contact')} className="mobile-menu-item">যোগাযোগ</button>
            <Link to="/banner" className="mobile-menu-item mobile-menu-item-banner" onClick={() => setIsMenuOpen(false)}>গর্বিত প্রতিযোগী ব্যানার</Link>
          </div>
        )}
      </header>

      <main>
        {/* Hero Section */}
        <section id="home" className="hero-section">
          <div className="hero-overlay" />
          <div className="hero-inner">
            <div className="hero-content animate-fade-in-up">
              <div className="title-sponsor-row">
                <img src={copperKettleLogo} alt="The Copper Kettle" className="title-sponsor-logo" />
                <span className="title-sponsor-text">The Copper Kettle Presents</span>
              </div>
              <p className="hero-organizer">স্বপ্নতরী পরিবারের উদ্যোগে</p>
              <h1 className="hero-title">সেরা পুজো</h1>
              <h1 className="hero-year">১৪৩৩</h1>
              <div className="hero-badge animate-float">রেজিস্ট্রেশন শুরু হয়েছে!</div>
              <div className="hero-stats">
                <div className="hero-stat">
                  <span className="stat-value">২৫+</span>
                  <span className="stat-label">পুরস্কার</span>
                </div>
                <div className="stat-divider" />
                <div className="hero-stat">
                  <span className="stat-value">₹৫০০</span>
                  <span className="stat-label">প্রবেশমূল্য</span>
                </div>
                <div className="stat-divider" />
                <div className="hero-stat">
                  <span className="stat-value">৩</span>
                  <span className="stat-label">বিভাগ</span>
                </div>
              </div>
              <div className="hero-buttons">
                <a href="https://forms.gle/B46FtamY4rJNJf8UA" target="_blank" rel="noopener noreferrer" className="hero-cta-button animate-pulse-slow">
                  এখনই রেজিস্ট্রেশন করুন
                </a>
                <a href="tel:+916289492935" className="hero-secondary-button">
                  <Phone size={18} />
                  অথবা কল করুন
                </a>
                <Link to="/banner" className="hero-secondary-button">
                  <ImageIcon size={18} />
                  গর্বিত প্রতিযোগী ব্যানার বানান
                </Link>
                <a href={ANDROID_APK_URL} download className="hero-secondary-button">
                  <Download size={18} />
                  Android অ্যাপ ডাউনলোড করুন
                </a>
                <button onClick={() => setShowIOSInstallHint(true)} className="hero-secondary-button">
                  <Download size={18} />
                  iOS অ্যাপ ডাউনলোড করুন
                </button>
              </div>
            </div>

            <div className="hero-art animate-fade-in-right">
              <div className="hero-art-glow" />
              <div className="hero-art-ring" />
              <img src={durgaHeroImage} alt="মা দুর্গা" className="hero-art-img" />
            </div>
          </div>
        </section>

        {/* Title Sponsor Section */}
        <section className="sponsor-section">
          <div className="sponsor-overlay" />
          <div className="sponsor-inner animate-fade-in-up">
            <span className="sponsor-label">টাইটেল স্পনসর</span>
            <div className="sponsor-divider">
              <span className="sponsor-divider-line" />
              <span className="sponsor-divider-icon">❖</span>
              <span className="sponsor-divider-line" />
            </div>
            <div className="sponsor-logo-card">
              <img src={copperKettleLogo} alt="The Copper Kettle" className="sponsor-logo" />
            </div>
            <h2 className="sponsor-name">The Copper Kettle</h2>
            <p className="sponsor-tagline">Café &amp; Restaurant</p>
            <p className="sponsor-presents">Presents</p>
            <h3 className="sponsor-event-name">সেরা পুজো ১৪৩৩</h3>
          </div>
        </section>

        {/* Schedule Cards */}
        <section className="schedule-section">
          <div className="schedule-grid">
            <div className="schedule-card animate-fade-in-left">
              <div className="schedule-icon"><Calendar size={28} /></div>
              <div>
                <div className="schedule-label">অফলাইন ভিজিট</div>
                <div className="schedule-value">পঞ্চমীর দিন</div>
              </div>
            </div>
            <div className="schedule-card schedule-card-gold animate-fade-in-up">
              <div className="schedule-icon"><Trophy size={28} /></div>
              <div>
                <div className="schedule-label">পুরস্কার প্রদান</div>
                <div className="schedule-value">সপ্তমীর দিন</div>
              </div>
            </div>
            <div className="schedule-card animate-fade-in-right">
              <div className="schedule-icon"><MapPin size={28} /></div>
              <div>
                <div className="schedule-label">অফলাইন পরিদর্শন এলাকা</div>
                <div className="schedule-value">চুঁচুড়া, ব্যান্ডেল ও চন্দননগর</div>
              </div>
            </div>
          </div>
        </section>

        {/* Photo Gallery */}
        <PhotoGallery />

        {/* Poster Section */}
        <section className="poster-section">
          <div className="poster-container">
            <img src={posterImage} alt="সেরা পুজো ১৪৩৩ পোস্টার" className="poster-image" />
          </div>
        </section>

        {/* Competition Details */}
        <section id="competition" className="competition-section">
          <div className="section-container">
            <h2 className="section-title animate-fade-in-up">প্রতিযোগিতার বিবরণ</h2>

            <div className="info-card animate-scale-in">
              <div className="info-card-header">
                <span className="info-icon">🎊</span>
                <h3>সেরা পুজো ১৪৩৩ সম্পর্কে</h3>
              </div>
              <p className="info-text">
                শারদোৎসবকে আরও আনন্দময় ও প্রতিযোগিতামূলক করে তুলতে আমাদের স্বপ্নতরী পরিবারের পক্ষ থেকে আবারও আয়োজন করা হয়েছে <strong>"সেরা পুজো ১৪৩৩"</strong> প্রতিযোগিতার। এবার থেকে <strong>পুরো দেশ জুড়ে</strong> যে কেউ এই প্রতিযোগিতায় অংশগ্রহণ করতে পারবেন।
              </p>

              <div className="details-grid">
                <div className="detail-pill">
                  <span className="detail-icon">🔥</span>
                  <div>
                    <div className="detail-title">অংশগ্রহণকারী</div>
                    <div className="detail-desc">বারোয়ারি / ক্লাবের পুজো কমিটি এবং বাড়ির পুজো</div>
                  </div>
                </div>
                <div className="detail-pill detail-pill-gold">
                  <span className="detail-icon">💰</span>
                  <div>
                    <div className="detail-title">প্রবেশমূল্য</div>
                    <div className="detail-desc">₹৫০০ প্রতি পুজো</div>
                  </div>
                </div>
                <div className="detail-pill">
                  <span className="detail-icon">📍</span>
                  <div>
                    <div className="detail-title">অংশগ্রহণ এলাকা</div>
                    <div className="detail-desc">পুরো দেশ জুড়ে যে কেউ অংশগ্রহণ করতে পারবেন</div>
                  </div>
                </div>
                <div className="detail-pill detail-pill-gold">
                  <span className="detail-icon">🎁</span>
                  <div>
                    <div className="detail-title">মোট পুরস্কার</div>
                    <div className="detail-desc">২৫টি পুরস্কার (বৃদ্ধি হতে পারে)</div>
                  </div>
                </div>
                <div className="detail-pill">
                  <span className="detail-icon">⏰</span>
                  <div>
                    <div className="detail-title">রেজিস্ট্রেশনের শেষ তারিখ</div>
                    <div className="detail-desc">৮ই অক্টোবর, বিকেল ৫টা</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Rules */}
            <div className="rules-card animate-fade-in-up">
              <h3 className="rules-title">
                <span>📋</span> নিয়মাবলী ও বিবরণ
              </h3>
              <ul className="rules-list">
                <li><strong>চুঁচুড়া, ব্যান্ডেল ও চন্দননগর</strong> এলাকার পুজোর জন্য বিচারকমণ্ডলী নির্ধারিত দিনে (<strong>পঞ্চমী</strong>) সরাসরি পুজো পরিদর্শন করবেন</li>
                <li>দেশের বাকি অংশের পুজোর জন্য অনলাইনে বিচার করা হবে</li>
                <li><strong>পুরো দেশ জুড়ে</strong> যেকোনো বারোয়ারি / ক্লাবের পুজো কমিটি এবং বাড়ির পুজো অংশগ্রহণ করতে পারবে</li>
                <li>প্রতিযোগীর সংখ্যা ও অংশগ্রহণের ভিত্তিতে পুরস্কারের সংখ্যা আরও বৃদ্ধি করা হতে পারে</li>
                <li className="rules-important">রেজিস্ট্রেশনের শেষ তারিখ <strong>৮ই অক্টোবর, বিকেল ৫টা</strong></li>
                <li>পুরস্কার বিতরণ হবে <strong>সপ্তমীর দিন</strong></li>
                <li>ফর্ম পূরণ হয়ে গেলে WhatsApp গ্রুপে যোগ করা হবে — সমস্ত তথ্য সেখানেই দেওয়া হবে</li>
                <li className="rules-important">বিচারকমণ্ডলীর সিদ্ধান্তই চূড়ান্ত সিদ্ধান্ত হিসেবে গণ্য হবে</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Prizes Section */}
        <section id="prizes" className="prizes-section">
          <div className="section-container">
            <h2 className="section-title section-title-light animate-fade-in-up">পুরস্কারের বিভাগসমূহ</h2>
            <p className="prizes-subtitle">মোট ২৫টি পুরস্কার • সেরার সেরা ১৪৩৩</p>

            <div className="prizes-grid">
              {/* বিভাগ ক */}
              <div className="prize-category-card animate-fade-in-left">
                <div className="category-header">
                  <div className="category-badge">বিভাগ 'ক'</div>
                  <p className="category-budget">বাজেট ₹৫ লক্ষের বেশি</p>
                </div>
                <div className="award-group">
                  <div className="award-type">
                    <span className="award-type-icon">🏅</span>
                    <span className="award-type-name">মণ্ডপ</span>
                  </div>
                  <div className="medal-list">
                    <div className="medal-item gold">🥇 প্রথম</div>
                    <div className="medal-item silver">🥈 দ্বিতীয়</div>
                    <div className="medal-item bronze">🥉 তৃতীয়</div>
                  </div>
                </div>
                <div className="award-divider" />
                <div className="award-group">
                  <div className="award-type">
                    <span className="award-type-icon">🪔</span>
                    <span className="award-type-name">প্রতিমা</span>
                  </div>
                  <div className="medal-list">
                    <div className="medal-item gold">🥇 প্রথম</div>
                    <div className="medal-item silver">🥈 দ্বিতীয়</div>
                    <div className="medal-item bronze">🥉 তৃতীয়</div>
                  </div>
                </div>
              </div>

              {/* বিভাগ খ */}
              <div className="prize-category-card animate-fade-in-up">
                <div className="category-header">
                  <div className="category-badge">বিভাগ 'খ'</div>
                  <p className="category-budget">বাজেট ₹৫ লক্ষের কম</p>
                </div>
                <div className="award-group">
                  <div className="award-type">
                    <span className="award-type-icon">🏅</span>
                    <span className="award-type-name">মণ্ডপ</span>
                  </div>
                  <div className="medal-list">
                    <div className="medal-item gold">🥇 প্রথম</div>
                    <div className="medal-item silver">🥈 দ্বিতীয়</div>
                    <div className="medal-item bronze">🥉 তৃতীয়</div>
                  </div>
                </div>
                <div className="award-divider" />
                <div className="award-group">
                  <div className="award-type">
                    <span className="award-type-icon">🪔</span>
                    <span className="award-type-name">প্রতিমা</span>
                  </div>
                  <div className="medal-list">
                    <div className="medal-item gold">🥇 প্রথম</div>
                    <div className="medal-item silver">🥈 দ্বিতীয়</div>
                    <div className="medal-item bronze">🥉 তৃতীয়</div>
                  </div>
                </div>
              </div>

              {/* সাবেকি প্রতিমা */}
              <div className="prize-category-card animate-fade-in-right">
                <div className="category-header">
                  <div className="category-badge category-badge-alt">সাবেকি প্রতিমা</div>
                  <p className="category-budget">সাবেকি বিভাগ</p>
                </div>
                <div className="award-group">
                  <div className="award-type">
                    <span className="award-type-icon">🪔</span>
                    <span className="award-type-name">সাবেকি প্রতিমা</span>
                  </div>
                  <div className="medal-list">
                    <div className="medal-item gold">🥇 প্রথম</div>
                    <div className="medal-item silver">🥈 দ্বিতীয়</div>
                    <div className="medal-item bronze">🥉 তৃতীয়</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Grand Prize */}
            <div className="grand-prize-card animate-scale-in">
              <div className="grand-prize-glow" />
              <div className="grand-prize-content">
                <div className="grand-prize-crown">👑</div>
                <h3 className="grand-prize-title">সর্বোচ্চ সম্মান</h3>
                <h2 className="grand-prize-name">সেরার সেরা ১৪৩৩</h2>
                <p className="grand-prize-desc">
                  সমস্ত প্রতিযোগী পুজোর মধ্যে থেকে নির্বাচন করা হবে এবারের "সেরার সেরা ১৪৩৩"
                </p>
                <div className="grand-prize-stars">
                  <Star size={16} fill="currentColor" />
                  <Star size={20} fill="currentColor" />
                  <Star size={24} fill="currentColor" />
                  <Star size={20} fill="currentColor" />
                  <Star size={16} fill="currentColor" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="contact-section">
          <div className="section-container">
            <h2 className="section-title animate-fade-in-up">যোগাযোগ করুন</h2>
            <div className="contact-card animate-scale-in">
              <div className="contact-grid">
                <div className="contact-info-block animate-fade-in-left">
                  <div className="contact-logo-wrap animate-float">
                    <img src={logoImage} alt="স্বপ্নতরী" className="contact-logo" />
                  </div>
                  <h3 className="contact-brand">স্বপ্নতরী</h3>
                  <p className="contact-tagline">সেরা পুজো ১৪৩৩ আয়োজক</p>
                  <div className="social-buttons">
                    <a
                      href="https://www.facebook.com/groups/766326619283876"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="facebook-button"
                    >
                      <Facebook size={20} className="social-button-icon" />
                      <span>আমাদের ফেসবুক গ্রুপ</span>
                    </a>
                    <a
                      href="https://www.instagram.com/swapnatari.in?utm_source=qr&stkn=MTluMmI2anRldmt4aA=="
                      target="_blank"
                      rel="noopener noreferrer"
                      className="instagram-button"
                    >
                      <Instagram size={20} className="social-button-icon" />
                      <span>ইনস্টাগ্রাম</span>
                    </a>
                  </div>
                </div>

                <div className="contact-details-block animate-fade-in-right">
                  <h3 className="contact-cta-title">তাহলে আর দেরি কেন?</h3>
                  <p className="contact-cta-text">
                    আপনার পুজোকে অংশগ্রহণ করান "সেরা পুজো ১৪৩৩"-এ এবং হয়ে উঠুন এবারের সেরাদের সেরা!
                  </p>

                  <div className="contact-items">
                    <a href="https://forms.gle/B46FtamY4rJNJf8UA" target="_blank" rel="noopener noreferrer" className="contact-item contact-item-register">
                      <div className="contact-item-icon contact-item-icon-gold">📋</div>
                      <div className="contact-item-text">
                        <div className="contact-item-label">অনলাইন রেজিস্ট্রেশন</div>
                        <div className="contact-item-value">ফর্ম পূরণ করুন এখানে</div>
                      </div>
                    </a>
                    <a href="tel:+916289492935" className="contact-item contact-item-phone">
                      <div className="contact-item-icon"><Phone size={22} /></div>
                      <div className="contact-item-text">
                        <div className="contact-item-label">অথবা কল করুন</div>
                        <div className="contact-item-value">+91 6289 492 935</div>
                      </div>
                    </a>
                    <a href="mailto:swapnatari.contact@gmail.com" className="contact-item">
                      <div className="contact-item-icon"><Mail size={22} /></div>
                      <div className="contact-item-text">
                        <div className="contact-item-label">ইমেইল করুন</div>
                        <div className="contact-item-value">swapnatari.contact@gmail.com</div>
                      </div>
                    </a>
                    <div className="contact-item">
                      <div className="contact-item-icon"><MapPin size={22} /></div>
                      <div className="contact-item-text">
                        <div className="contact-item-label">অফলাইন পরিদর্শন এলাকা</div>
                        <div className="contact-item-value">চুঁচুড়া, ব্যান্ডেল ও চন্দননগর, হুগলি</div>
                      </div>
                    </div>
                  </div>

                  <div className="contact-note">
                    🌏 পুরো দেশ জুড়ে যে কেউ অংশগ্রহণ করতে পারবেন
                  </div>
                  <div className="contact-note">
                    🎯 প্রতিযোগীর সংখ্যার ভিত্তিতে পুরস্কারের সংখ্যা আরও বৃদ্ধি করা হতে পারে
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-inner">
          <img src={logoImage} alt="স্বপ্নতরী" className="footer-logo" />
          <p className="footer-text">সেরা পুজো ১৪৩৩ • স্বপ্নতরী পরিবার</p>
          <div className="footer-app-links">
            <a href={ANDROID_APK_URL} download className="footer-apk-link">
              <Download size={16} />
              Android অ্যাপ ডাউনলোড করুন
            </a>
            <button onClick={() => setShowIOSInstallHint(true)} className="footer-apk-link">
              <Download size={16} />
              iOS অ্যাপ ডাউনলোড করুন
            </button>
          </div>
          <p className="footer-copy">&copy; {new Date().getFullYear()} স্বপ্নতরী। সর্বস্বত্ব সংরক্ষিত।</p>
        </div>
      </footer>

      {showIOSInstallHint && (
        <div className="ios-install-backdrop" onClick={() => setShowIOSInstallHint(false)}>
          <div className="ios-install-modal" onClick={(e) => e.stopPropagation()}>
            <button className="ios-install-close" onClick={() => setShowIOSInstallHint(false)}>
              <X size={20} />
            </button>
            <img src={logoImage} alt="স্বপ্নতরী" className="ios-install-logo" />
            <h3>আপনার iPhone-এ অ্যাপ ইনস্টল করুন</h3>
            <div className="ios-install-step">
              <Share size={20} />
              <span>নিচের <strong>Share</strong> বাটনে ট্যাপ করুন</span>
            </div>
            <div className="ios-install-step">
              <PlusSquare size={20} />
              <span><strong>"Add to Home Screen"</strong> নির্বাচন করুন</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomePage;
